import request from '@/utils/request'


// 查询为你提供列表
export function listForYou(query) {
  return request({
    url: '/provide/forYou/list',
    method: 'get',
    params: query
  })
}

// 查询为你提供分页
export function pageForYou(query) {
  return request({
    url: '/provide/forYou/page',
    method: 'get',
    params: query
  })
}

// 查询为你提供详细
export function getForYou(data) {
  return request({
    url: '/provide/forYou/detail',
    method: 'get',
    params: data
  })
}

// 新增为你提供
export function addForYou(data) {
  return request({
    url: '/provide/forYou/add',
    method: 'post',
    data: data
  })
}

// 修改为你提供
export function updateForYou(data) {
  return request({
    url: '/provide/forYou/edit',
    method: 'post',
    data: data
  })
}

// 删除为你提供
export function delForYou(data) {
  return request({
    url: '/provide/forYou/delete',
    method: 'post',
    data: data
  })
}
